var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isOpen)?_c('button',{staticClass:"expo-btn expo-btn-white aside-menu-open-button mt-0 hidden lg:inline-block",on:{"click":_vm.toggleAsideMenu}},[_c('div'),_c('div'),_c('div')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }